import { createSlice, WithSlice } from '@reduxjs/toolkit';
import type { AutoConfiguratorState } from '@snap-types/models/auto-configurator/state';
import { AUTO_CONFIGURATOR_SLICE_NAME } from '@ui/constants/auto-configurator';
import { createImportAlphaSpreadsheetReducer } from '@ui/features/alpha/state/extra-reducers/import-alpha-spreadsheet';
import { createViewAlphaQuoteReducer } from '@ui/features/alpha/state/extra-reducers/view-alpha-quote';
import { rootReducer } from '@ui/store';
import { WritableDraft } from 'immer';

import { initialState } from './initial-state';
import * as reducers from './reducers';
import * as selectors from './selectors';

const autoConfiguratorSlice = createSlice({
  name: AUTO_CONFIGURATOR_SLICE_NAME,
  initialState,
  reducers,
  selectors,
  extraReducers: (builder) => {
    createImportAlphaSpreadsheetReducer(builder);
    createViewAlphaQuoteReducer(builder);
  },
});

const injectedAutoConfiguratorSlice =
  autoConfiguratorSlice.injectInto(rootReducer);

export const {
  actions: autoConfiguratorActions,
  selectors: autoConfiguratorSelectors,
} = injectedAutoConfiguratorSlice;

declare module '@ui/store' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  export interface LazyLoadedSlices
    extends WithSlice<typeof autoConfiguratorSlice> {}
}

export type WritableAutoConfiguratorState =
  WritableDraft<AutoConfiguratorState>;
